import cuid from 'cuid';

export const ADD_ALERT = 'app/ADD_ALERT';
export const REMOVE_ALERT = 'app/REMOVE_ALERT';
export const REMOVE_ALL_ALERTS = 'app/REMOVE_ALL_ALERTS';

export const ADD_SPINNER = 'app/ADD_SPINNER';
export const REMOVE_SPINNER = 'app/REMOVE_SPINNER';
export const REMOVE_ALL_SPINNERS = 'app/REMOVE_ALL_SPINNERS';

export const ADD_MODAL = 'app/ADD_MODAL';
export const REMOVE_MODAL = 'app/REMOVE_MODAL';

export const ADD_DATE_FILTER = 'app/ADD_DATE_FILTER';

export const TOGGLE_MENU = 'app/TOGGLE_MENU';

export const removeAlert = id => dispatch => {
  return dispatch({
    type: REMOVE_ALERT,
    id,
  });
};

export const addAlert =
  ({message, variant, duration = 10000, id = cuid()}) =>
  dispatch => {
    if (!message) {
      return;
    }

    const validVariant = ['error', 'info', 'success', 'warning'];
    const testedVariant =
      variant && validVariant.indexOf(variant) !== -1 ? variant : 'info';

    dispatch({
      type: ADD_ALERT,
      payload: {
        id,
        message,
        variant: testedVariant,
        duration,
      },
    });

    if (duration && duration !== 0) {
      setTimeout(
        () =>
          dispatch({
            type: REMOVE_ALERT,
            id,
          }),
        duration,
      );
    }
  };

export const removeAllAlerts = () => dispatch => {
  return dispatch({
    type: REMOVE_ALL_ALERTS,
  });
};

export const addSpinner = (id, message) => async dispatch => {
  const payload = {
    id,
  };

  if (message) {
    payload.message = message;
  }

  return dispatch({
    type: ADD_SPINNER,
    payload,
  });
};

export const removeSpinner = id => async dispatch => {
  return dispatch({
    type: REMOVE_SPINNER,
    id,
  });
};

export const removeAllSpinners = () => dispatch => {
  return dispatch({
    type: REMOVE_ALL_SPINNERS,
  });
};

export const addModal = id => dispatch => {
  return dispatch({
    type: ADD_MODAL,
    id,
  });
};

export const removeModal = () => dispatch => {
  return dispatch({
    type: REMOVE_MODAL,
  });
};

export const addDateFilter = payload => dispatch => {
  return dispatch({
    type: ADD_DATE_FILTER,
    payload,
  });
};

export const toggleMainMenu = () => dispatch => dispatch({type: TOGGLE_MENU});

const initialState = {
  alerts: [],
  spinners: [],
  modal: null,
  isMenuOpen: false,
  dateFilter: {startDate: null, endDate: null},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MENU:
      return {
        ...state,
        isMenuOpen: !state.isMenuOpen,
      };

    case ADD_ALERT: {
      const alertsArray = [...state.alerts, action.payload];

      return {
        ...state,
        alerts: alertsArray.slice(-4), // last 4 alerts max
      };
    }

    case REMOVE_ALERT:
      return {
        ...state,
        alerts: state.alerts.filter(alert => alert.id !== action.id),
      };

    case REMOVE_ALL_ALERTS:
      return {
        ...state,
        alerts: [],
      };

    case ADD_SPINNER:
      return {
        ...state,
        spinners: [...state.spinners, action.payload],
      };

    case REMOVE_SPINNER:
      return {
        ...state,
        spinners: state.spinners.filter(spinner => spinner.id !== action.id),
      };

    case REMOVE_ALL_SPINNERS:
      return {
        ...state,
        spinners: [],
      };

    case ADD_MODAL: {
      if (!state.modal || action.id !== state.modal) {
        return {
          ...state,
          modal: action.id,
        };
      }

      return state;
    }

    case REMOVE_MODAL:
      return {
        ...state,
        modal: null,
      };

    case ADD_DATE_FILTER:
      return {
        ...state,
        dateFilter: action.payload,
      };
    default:
      return state;
  }
};
